<template>
  <el-dialog
    title="礼物卡设置"
    :visible.sync="visible"
    width="800px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="form"
      label-width="90px">
      <el-form-item
        label="显示入口:"
        prop="status">
        <el-switch
          v-model="form.status"
          active-color="#13ce66"
          :active-value="1"
          inactive-color="#ff4949"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item
        label="卡片"
        prop="imageList">
        <upload-with-crop
          v-model="form.imageList"
          :cropper="true"
          :limit="5"
          :fixedNumber="[5,3]"
          :autoCropWidth="120"
          :autoCropHeight="72" />
      </el-form-item>

    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import UploadWithCrop from '@/components/wx/upload-with-crop.vue'
export default {
  name: 'GiftsCardModal',
  components: { UploadWithCrop },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        status: 0,
        imageList: []
      },
      rules: {
        imageList: [
          { required: true, message: '请上传卡片', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('settings/configgiftcard', {
            payload: {
              vendorId: this.userInfo.vendorId,
              status: this.form.status,
              giftCards: this.form.imageList.map(i => {
                return {
                  cardImage: i.url,
                  giftCardId: i.giftCardId
                }
              })
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getsetting() {
      this.loading = true
      this.$store.dispatch('settings/getgiftcardconfig', {
        payload: {
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          this.form = {
            ...this.form,
            ...res.data,
            imageList: res.data.giftCards.map(i => {
              i.url = i.cardImage
              return i
            })
          }
          this.toggleModal(true)
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
